// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-item {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-bottom: 10px;
    /*background-color: #f9f9f9;*/
    transition: background-color 0.3s ease;
}

.task-item.bg-secondary {
    /*background-color: #6c757d;*/
}

.task-details {
    display: flex;
    align-items: center;
    flex-grow: 1;
}

.task-name {
    flex-basis: 60%;
    margin-right: 10px;
    padding: 5px;
    border-radius: 4px;
    border: 1px solid #ddd;
    /*background-color: #fff;*/
}

.task-category {
    flex-basis: 30%;
    margin-right: 10px;
}

.task-expected-time {
    flex-basis: 2%;
    margin-right: 10px;
}

.task-weight {
    flex-basis: 8%;
    margin-right: 10px;
}

.task-actions {
    display: flex;
    align-items: center;
}

.task-progress-bar {
    height: 20px;
    margin-top: 10px;
}

.btn {
    transition: background-color 0.3s ease, color 0.3s ease;
}

.btn-sm {
    padding: 5px 10px;
    font-size: 0.875rem;
}

.btn-sm.me-2 {
    margin-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/GoalManager/Task.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".task-item {\r\n    padding: 10px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    margin-bottom: 10px;\r\n    /*background-color: #f9f9f9;*/\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\n.task-item.bg-secondary {\r\n    /*background-color: #6c757d;*/\r\n}\r\n\r\n.task-details {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-grow: 1;\r\n}\r\n\r\n.task-name {\r\n    flex-basis: 60%;\r\n    margin-right: 10px;\r\n    padding: 5px;\r\n    border-radius: 4px;\r\n    border: 1px solid #ddd;\r\n    /*background-color: #fff;*/\r\n}\r\n\r\n.task-category {\r\n    flex-basis: 30%;\r\n    margin-right: 10px;\r\n}\r\n\r\n.task-expected-time {\r\n    flex-basis: 2%;\r\n    margin-right: 10px;\r\n}\r\n\r\n.task-weight {\r\n    flex-basis: 8%;\r\n    margin-right: 10px;\r\n}\r\n\r\n.task-actions {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.task-progress-bar {\r\n    height: 20px;\r\n    margin-top: 10px;\r\n}\r\n\r\n.btn {\r\n    transition: background-color 0.3s ease, color 0.3s ease;\r\n}\r\n\r\n.btn-sm {\r\n    padding: 5px 10px;\r\n    font-size: 0.875rem;\r\n}\r\n\r\n.btn-sm.me-2 {\r\n    margin-right: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
